<ion-content [fullscreen]="true">
  <div class="wrapper-form">
    <div *ngIf="!PersonFacade.submitted">
      <img class="logo" src="../../../assets/icon/fais_group_logo.jpg" />
      <ion-qc-person-details-form
        [personDetails]="personDetails"
      ></ion-qc-person-details-form>

      <ion-row
        ><ion-button [disabled]="PersonFacade.formIsValid" (click)="submit()"
          >Υποβολή</ion-button
        ></ion-row
      >
    </div>
  </div>

  <div *ngIf="PersonFacade.submitted" class="align-text-container">
    <img
      class="logo-after-submission"
      src="../../../assets/icon/fais_group_logo.jpg"
    />
    <ion-label *ngIf="PersonFacade.isDataUpdated" class="align-text">
      Η εγγραφή σας ολοκληρώθηκε επιτυχώς.
    </ion-label>
    <ion-label *ngIf="!PersonFacade.isDataUpdated" class="align-text">
      Υπήρξε ένα πρόβλημα κατά την εγγραφή σας.
    </ion-label>
  </div>
</ion-content>
